export const GET_EMPLOYEES_REQUEST = "GET_EMPLOYEES_REQUEST"
export const EMPLOYEE_DETAILS_REQUEST = "EMPLOYEE_DETAILS_REQUEST"
export const EMPLOYEE_CREATE_REQUEST = "EMPLOYEE_CREATE_REQUEST"
export const EMPLOYEE_DELETE_REQUEST = "EMPLOYEE_DELETE_REQUEST"
export const EMPLOYEE_DEACTIVATE_REQUEST = "EMPLOYEE_DEACTIVATE_REQUEST"
export const EMPLOYEE_ACTIVATE_REQUEST = "EMPLOYEE_ACTIVATE_REQUEST"
export const EMPLOYEE_UPDATE_REQUEST = "EMPLOYEE_UPDATE_REQUEST"
export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"
export const MANAGE_ADMIN_USER = "MANAGE_ADMIN_USER"
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST"
export const GET_USER_REQUEST = "GET_USER_REQUEST"
export const USER_IMAGE_UPLOAD_REQUEST = "USER_IMAGE_UPLOAD_REQUEST"





